import { useEffect, useState } from "react";
import { getQuery } from "lib";
import defaultCurrency from "config/defaultCurrency";
import defaultLangList from "config/defaultLangList";

const is168 = process.env.REACT_APP_SITE_TYPE === "168";

const useGetQuery = () => {
  const QueryGameId = () => {
    if (getQuery("gameid").match("VPTW")) {
      if (
        (getQuery("gameid").match("VPTW") && getQuery("gameid").match("_1")) ||
        getQuery("gameid").match("_2")
      ) {
        return getQuery("gameid")
          .replace("VPTW", "VPAA")
          .replace("_1", "")
          .replace("_2", "");
      } else {
        return getQuery("gameid").replace("VPTW", "VPAA");
      }
    } else if (getQuery("gameid").match("VPAA")) {
      if (getQuery("gameid").match("_1") || getQuery("gameid").match("_2")) {
        return getQuery("gameid").replace("_1", "").replace("_2", "");
      } else {
        return getQuery("gameid");
      }
    } else if (getQuery("gameid").match("VPCQ")) {
      if (getQuery("gameid").match("_1") || getQuery("gameid").match("_2") || getQuery("gameid").match("_3")) {
        return getQuery("gameid")
          .replace("VPCQ", "VPAA")
          .replace("_1", "")
          .replace("_2", "")
          .replace("_3", "");
      } else {
        return getQuery("gameid").replace("VPCQ", "VPAA");
      }
    } else {
      return getQuery("gameid") === "7006"
        ? "GB6"
        : getQuery("gameid") === "7012"
        ? "GB12"
        : getQuery("gameid");
    }
  };
  const gameId = QueryGameId();
  const [defaultLang, setDefaultLang] = useState("");
  const [minExtra, setMinExtra] = useState(0);
  const [maxExtra, setMaxExtra] = useState(0);
  const [denom, setDenom] = useState(1);
  const [bet, setBet] = useState(0);
  const [betLevel, setBetLevel] = useState(1);
  const [isSoundOn, setIsSoundOn] = useState(true);
  const [currency, setCurrency] = useState("default");
  const [isCurrency, setIsCurrency] = useState(false);

  useEffect(() => {
    const QueryLang = getQuery("language");

    const QueryExtra = getQuery("extra");
    const QueryDenom = getQuery("denom");
    const QueryBet = getQuery("bet");
    const QueryBetLevel = getQuery("betLevel");
    const QueryCurrency =
      getQuery("currency") && getQuery("currency").toLowerCase();
    const QueryIsCurrency = getQuery("isCurrency");
    const QuerySoundOn = getQuery("soundOn");
    QueryExtra && setMinExtra(QueryExtra.split(",")[0]);
    QueryExtra && setMaxExtra(QueryExtra.split(",")[1]);
    QueryDenom && setDenom(QueryDenom);
    QueryBet && setBet(QueryBet);
    QueryBetLevel && setBetLevel(QueryBetLevel);
    if (QuerySoundOn === "false") {
      setIsSoundOn(false);
    }
    if (QueryIsCurrency === "true") {
      setIsCurrency(true);
    }
    is168
      ? setDefaultLang("zh-tw")
      : QueryLang === "zh-cn"
      ? setDefaultLang("cn")
      : QueryLang
      ? defaultLangList().includes(QueryLang)
        ? setDefaultLang(QueryLang)
        : setDefaultLang("en")
      : setDefaultLang("cn");
    if( getQuery("gameid")==="VPTWS34_1" || getQuery("gameid")==="VPTWS28_1" || getQuery("gameid")==="VPTWS29_1"){
      setDefaultLang("cn");
    }
    if( getQuery("gameid")==="VPTWS33_3" || getQuery("gameid")==="VPTWS35_3"){
      setDefaultLang("cn");
    }
    defaultCurrency().includes(QueryCurrency) && setCurrency(QueryCurrency);
  }, []);
  return {
    defaultLang,
    gameId,
    minExtra,
    maxExtra,
    denom,
    bet,
    betLevel,
    isSoundOn,
    currency,
    isCurrency,
  };
};

export default useGetQuery;
